import {Link, useParams} from 'react-router-dom'
import {useState} from 'react'
import {CustomerRoutingListPanel} from './CustomerRoutingListPanel'

type RoutingTab = 'exclusion' | 'priority'

/* eslint-disable jsx-a11y/anchor-is-valid */
export function RoutingView() {
  const {id} = useParams()
  const [activeTab, setActiveTab] = useState<RoutingTab>('exclusion')

  if (!id) {
    return null
  }

  return (
    <>
      <div className='modal fade' tabIndex={-1} id='kt_client_acc_rount'>
        <div className='modal-dialog modal-lg'>
          <div className='modal-content '>
            <div className='modal-header py-2'>
              <h4 className='modal-title'>Client Account Routing Settings</h4>
              <div
                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                data-bs-dismiss='modal'
                aria-label='Close'
              >
                <i className='bi bi-x fs-2'></i>
              </div>
            </div>
            <div className='modal-body' style={{maxHeight: '80vh', overflowY: 'scroll'}}>
              <p className='text-gray-500 mb-0' style={{fontSize: '12px'}}>
                Client account routing settings are under development.
              </p>
            </div>
            <div className='modal-footer py-3'>
              <button type='button' className='btn btn-light btn-sm' data-bs-dismiss='modal'>
                Cancel
              </button>
              <Link to='#'>
                <button type='button' className='btn btn-primary btn-sm'>
                  Save
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className='card-body p-0'>
        <div className='card-title d-flex align-items-center me-4 mb-3'>
          <div className='d-flex flex-column'>
            <div className='d-flex align-items-center'>
              <h5 className='text-black fs-4 fw-semibold mb-0'> Routing</h5>
            </div>
            <div className='d-flex flex-wrap fs-6'>
              <p className='text-gray-500 mb-0 fw-normal' style={{fontSize: '12px'}}>
                Manage interpreter exclusion and priority lists for this account. Priority
                interpreters are notified first during on-demand call routing.
              </p>
            </div>
          </div>
        </div>

        {process.env.REACT_APP_SERVER === 'DEV' && (
          <div className='row g-1 g-xl-1 mb-4'>
            <div className='col-md-12 col-sm-12'>
              <div className='border border-gray-500 border-dotted rounded p-5'>
                <div className='d-flex justify-content-between align-items-center w-100'>
                  <div className='d-flex fs-3 fw-semibold mb-0'>
                    Client account routing settings
                  </div>
                  <div className='d-flex align-items-center'>
                    <button
                      type='button'
                      className='btn btn-color-primary btn-active-primary btn-sm'
                      data-bs-toggle='modal'
                      data-bs-target='#kt_client_acc_rount'
                      style={{fontSize: '12px'}}
                    >
                      <i className='fa-solid fa-pen me-1' style={{fontSize: '12px'}}></i>
                      Edit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        <ul className='nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6'>
          <li className='nav-item'>
            <button
              type='button'
              className={`nav-link ${activeTab === 'exclusion' ? 'active' : ''}`}
              onClick={() => setActiveTab('exclusion')}
            >
              Exclusion
            </button>
          </li>
          <li className='nav-item'>
            <button
              type='button'
              className={`nav-link ${activeTab === 'priority' ? 'active' : ''}`}
              onClick={() => setActiveTab('priority')}
            >
              Priority
            </button>
          </li>
        </ul>

        <div className='row g-1 g-xl-4'>
          <div className='col-md-12 col-sm-12'>
            {activeTab === 'exclusion' && (
              <CustomerRoutingListPanel
                customerId={id}
                listType='exclusion'
                modalId='kt_interpreter_exclusion_list'
              />
            )}
            {activeTab === 'priority' && (
              <CustomerRoutingListPanel
                customerId={id}
                listType='priority'
                modalId='kt_interpreter_priority_list'
              />
            )}
          </div>
        </div>
      </div>
    </>
  )
}
